import { Flex, Typography } from '@aloft/toolkit-sui';

export const ExportModalPdfExport = () => (
  <Flex flexDirection="column">
    <Typography variant="h3">Toolkit PDFs</Typography>
    <Typography variant="body1">
      This will save a copy of the workfile documents to the downloads folder on your computer.
    </Typography>
  </Flex>
);
